import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {ThemeProvider} from "@material-ui/styles";
import theme from "./theme";
import TopBar from "./topBar";
import store from "./redux/store";
import {Provider} from "react-redux";
import "./index.css";
import {initDict} from "./dictionary";
import SlideRouter from "./wizard/slideRouter";
import {configureApi} from "./apiClient";
import moment from "moment";
import {initializeGoogleAnalytics, initializeGoogleTagManager} from "./googleHook";
import {Step} from "./wizard/WizardMap";
import {BrowserRouter} from "react-router-dom";

initDict();
configureApi();
initializeGoogleTagManager();
initializeGoogleAnalytics();
moment.defaultFormat = "DD.MM.YYYY";
const initialStep: Step = Step.OBJECT_TYPE;


const App: React.FC = () =>
    (<ThemeProvider theme={theme}>
        <Provider store={store}>
            <BrowserRouter>
                <TopBar/>
                <SlideRouter initialStep={initialStep}/>
            </BrowserRouter>
        </Provider>
    </ThemeProvider>);

export default App;
